<div class="card">
    <div class="card-body">
        <h5 class="card-title">Tìm kiếm nhật ký</h5>
        <form [formGroup]="searchForm">
            <div class="row">
                <div class="col">
                    <app-input-text label="Người thực hiện" placeholder="Nhập người thực hiện" [formGroup]="searchForm" formControlName="createUsernameLike"></app-input-text>
                </div>
                <div class="col">
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-input-select label="Thao tác" placeholder="Chọn thao tác" [formGroup]="searchForm" formControlName="action" [optionList]="loggingActionOptionList"></app-input-select>
                </div>
                <div class="col">
                    <app-input-text label="Dữ liệu" placeholder="Nhập dữ liệu" [formGroup]="searchForm" formControlName="loggingDataLike"></app-input-text>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-input-date label="Từ ngày" placeholder="Nhập từ ngày"[formGroup]="searchForm" formControlName="createDateGt"></app-input-date>
                </div>
                <div class="col">
                    <app-input-date label="Đến ngày" placeholder="Nhập đến ngày"[formGroup]="searchForm" formControlName="createDateLt"></app-input-date>
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-center">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" (click)="searchLogging()" [disabled]="loading"><span *ngIf="loading"  class="spinner-border spinner-border-sm"></span>Tìm kiếm</button>
        </div>
    </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <h5 class="card-title">Kết quả tìm kiếm</h5>
        <div class="alert alert-danger" role="alert" *ngIf="error">
          {{error}}
        </div>
        <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Thao tác</th>
                    <th scope="col">Dữ liệu</th>
                    <th scope="col">Người thực hiện</th>
                    <th scope="col">Ngày thực hiện</th>
                    <th scope="col">
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="sysLoggingList && !loading">
                <tr *ngFor="let sysLogging of sysLoggingList;index as sysLoggingIndex">
                    <td scope="col">{{(sysLoggingPagination.currentPage-1)*sysLoggingPagination.pageSize + sysLoggingIndex+1}}</td>
                    <td scope="col">{{loggingActionOptionMap[sysLogging.action]}}</td>
                    <td scope="col">{{sysLogging.loggingData}}</td>
                    <td scope="col">{{sysLogging.createUsername}}</td>
                    <td scope="col">{{sysLogging.createDate | date:'dd/MM/yyyy, HH:mm:ss'}}</td>
                    <td scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-info" (click)="viewLogging(sysLogging)">Xem</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <div class="d-flex justify-content-between align-items-center" *ngIf="sysLoggingPagination.pageCount>1 && !loading">
            <nav>
                <ul class="pagination">
                    <li class="page-item" [ngClass]="{'disabled':sysLoggingPagination.currentPage == 1}">
                      <a class="page-link" (click)="sysLoggingPageChange(sysLoggingPagination.currentPage-1)">Trước</a>
                    </li>
                    <li class="page-item" *ngIf="sysLoggingPagination.currentPage > 3">
                      <a class="page-link" (click)="sysLoggingPageChange(1)">1</a>
                    </li>
                  <li class="page-item disabled" *ngIf="sysLoggingPagination.currentPage > 3">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngFor="let page of sysLoggingPagination.pageList"  [ngClass]="{'active':sysLoggingPagination.currentPage == page}">
                    <a class="page-link" (click)="sysLoggingPageChange(page)">{{page}}</a>
                  </li>
                  <li class="page-item disabled" *ngIf="sysLoggingPagination.currentPage < sysLoggingPagination.pageCount - 2">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngIf="sysLoggingPagination.currentPage < sysLoggingPagination.pageCount - 2">
                    <a class="page-link" (click)="sysLoggingPageChange(sysLoggingPagination.pageCount)">{{sysLoggingPagination.pageCount}}</a>
                  </li>
                  <li class="page-item" [ngClass]="{'disabled':sysLoggingPagination.currentPage == sysLoggingPagination.pageCount}">
                    <a class="page-link"  (click)="sysLoggingPageChange(sysLoggingPagination.currentPage+1)">Sau</a>
                  </li>
                </ul>
              </nav>
        </div>
    </div>
</div>

